import * as React from "react";
import moment from "moment";
import { useRef } from "react";
import { logObject } from "../../../config/logs";
import { isDisable } from "./EditableCellConfig";
import ContextMenu from "./ContextMenu";
import "./dataMapTable.scss";
import { Tooltip } from "@mui/material";

const MIN_TEXTAREA_HEIGHT = 40;

const MemoisedTextArea = React.memo(
  ({
    role,
    parametersData,
    mapping,
    mappingIndex,
    rowRejectionData,
    parameterIndex,
    value,
    onChange,
    onBlur,
    isDataRejectedByProcessor,
    reProcess,
    isDataRejectedByValidator,
    reValidate,
    onClickMapping,
    onClickCellToRedirect,
    clearMappings,
    entireBatchRejectedByPro,
    entireBatchRejectedByVali,
    reProcessEntireBatch,
    showContextMenu,
    updateDataUsingManuallyContextMenu,
    isDataRejectedByInvestigatorMappingValidator,
    entireBatchRejectedByInvestigatorMappingValidator,
    isDataRejectedByInvestigatorValidator,
    entireBatchRejectedByInvestigatorValidator,
    // parameterKey,
    // onClickParameterKeyMapping,
  }) => {
    // We need to keep and update the state of the cell normally

    const textAreaRef = useRef(null);
    const resizeFrameRef = useRef(null);
    // const keyTextAreaRef = useRef(null);

    const [contextEvent, setContextEvent] = React.useState(null);

    const parameterData = parametersData?.[parameterIndex];

    const styleRejectedCell = (
      mapping,
      mappingIndex,
      rowRejectionData,
      parameterIndex,
    ) => {
      let backgroundColor = "#FFFF";

      if (role === "preProcessor") {
        // cell not mapping popup

        // Check if one of the inputs has a value while the other doesn't
        // const keyMappingPageNo =
        //   parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
        //     ?.pageNo;
        // const valueMappingPageNo =
        //   parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo;

        // const keyMappingCoordinatesLength =
        //   (parametersData[parameterIndex]?.mappings[mappingIndex]
        //     ?.keyCoordinates &&
        //     parametersData[parameterIndex]?.mappings[mappingIndex]
        //       ?.keyCoordinates?.length) ||
        //   0;
        // const valueMappingCoordinatesLength =
        //   (parametersData[parameterIndex]?.mappings[mappingIndex]
        //     ?.coordinates &&
        //     parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates
        //       ?.length) ||
        //   0;
        // if (
        //   parametersData[parameterIndex]?.mappings[mappingIndex]
        //     ?.forNoPreProMappingDataEntryByPro !== true
        // ) {
        //   if (
        // keyMappingPageNo !== "" &&
        // keyMappingPageNo !== undefined &&
        // keyMappingPageNo !== null &&
        // keyMappingPageNo >= 0 &&
        // valueMappingPageNo === "" ||
        // valueMappingPageNo === undefined ||
        // valueMappingPageNo === null ||
        // (valueMappingPageNo !== "" &&
        //   valueMappingPageNo !== undefined &&
        //   valueMappingPageNo !== null &&
        //   valueMappingPageNo >= 0)
        // &&
        // (
        //   keyMappingPageNo === "" ||
        //   keyMappingPageNo === undefined ||
        //   keyMappingPageNo === null
        // )
        // ) {
        //   backgroundColor = "rgb(241 238 137 / 41%)"; // Red background color
        // } else if (
        // (keyMappingPageNo !== "" &&
        //   keyMappingPageNo !== undefined &&
        //   keyMappingPageNo !== null &&
        //   keyMappingPageNo >= 0 &&
        //   keyMappingCoordinatesLength <= 0) ||
        //   valueMappingPageNo !== "" &&
        //   valueMappingPageNo !== undefined &&
        //   valueMappingPageNo !== null &&
        //   valueMappingPageNo >= 0 &&
        //   valueMappingCoordinatesLength <= 0
        // ) {
        //   backgroundColor = "rgb(241 238 137 / 41%)"; // Red background color
        // }
        // }

        // return { backgroundColor };

        // color when row or cell rej by pro
        if (
          mapping?.processorCellRejection?.isRejected ||
          parameterData?.processorRowRejection?.isRejected ||
          mapping?.investigatorMappingValidatiorCellRejection?.isRejected ||
          parameterData?.investigatorMappingValidatiorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(255 137 116)";
        }

        // dark red color for both rejection in cell and in row
        if (
          mapping?.processorCellRejection?.isRejected &&
          parameterData?.processorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        // dark red color for both rejection in cell and in row by mapping investigator
        if (
          mapping?.investigatorMappingValidatiorCellRejection?.isRejected &&
          parameterData?.investigatorMappingValidatiorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        // dark red color for both rejection in row
        if (
          rowRejectionData &&
          rowRejectionData.length > 0 &&
          rowRejectionData[mappingIndex]?.isRowRejectedByProcessor
        ) {
          backgroundColor = "rgb(253 97 71)";
        }
      }

      if (role === "processor") {
        // for resolved and Pro want to see comment'
        if (
          mapping?.processorCellRejection?.isResolved ||
          parameterData?.processorRowRejection?.isResolved
        ) {
          backgroundColor = "#CCE5FF";
        }
        if (
          mapping?.processorCellRejection?.isResolved &&
          parameterData?.processorRowRejection?.isResolved
        ) {
          backgroundColor = "#CCE5FF";
        }

        // any one rejected in cell or row in both role
        if (
          mapping?.processorCellRejection?.isRejected ||
          mapping?.validatorCellRejection?.isRejected ||
          parameterData?.processorRowRejection?.isRejected ||
          parameterData?.validatorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(255 137 116)";
        }

        // dark red color in cell for both role cell rejection only
        if (
          mapping?.processorCellRejection?.isRejected &&
          mapping?.validatorCellRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        // dark red when cell and row rej by processor
        if (
          mapping?.processorCellRejection?.isRejected &&
          parameterData?.processorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        // dark red color for both role rejection in row
        if (
          parameterData?.processorRowRejection?.isRejected &&
          parameterData?.validatorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        // dark red if row rejected by vali and cell rej by pro
        if (
          parameterData?.validatorRowRejection?.isRejected &&
          // valiRowRejectionDataInPro[mappingIndex]?.isRowRejectedByValidator &&
          mapping?.processorCellRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        // dark red if cell rejected by vali and row rej by pro
        if (
          mapping?.validatorCellRejection?.isRejected &&
          parameterData?.processorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        // dark red if cell rejected by vali and also row rej by vali
        if (
          mapping?.validatorCellRejection?.isRejected &&
          parameterData?.validatorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 97 71)";
        }
        // if cell is rej by vali and also row rejected and also cell rej by pro
        if (
          mapping?.validatorCellRejection?.isRejected &&
          parameterData?.validatorRowRejection?.isRejected &&
          mapping?.processorCellRejection?.isRejected
        ) {
          backgroundColor = "rgb(249 61 61)";
        }
        //  if cell is rej by vali and also row rejected and also row rej by pro
        if (
          mapping?.validatorCellRejection?.isRejected &&
          parameterData?.validatorRowRejection?.isRejected &&
          parameterData?.processorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(253 32 32)";
        }
        if (
          mapping?.processorCellRejection?.isRejected &&
          mapping?.validatorCellRejection?.isRejected &&
          parameterData?.validatorRowRejection?.isRejected &&
          parameterData?.processorRowRejection?.isRejected
        ) {
          backgroundColor = "rgb(235 44 109)";
        }
      }
      if (role === "validator") {
        const validatorCellRejected =
          mapping?.validatorCellRejection?.isRejected;

        const validatorRowRejected =
          parameterData?.validatorRowRejection?.isRejected;

        const investigatorCellRejected =
          mapping?.investigatorValidatiorCellRejection?.isRejected;

        const investigatorRowRejected =
          parameterData?.investigatorValidatiorRowRejection?.isRejected;

        const validatorCellResolved =
          mapping?.validatorCellRejection?.isResolved;

        const validatorRowResolved =
          parameterData?.validatorRowRejection?.isResolved;

        const isValidated = parameterData?.rowValidation?.isValidated;

        /* -----------------------------
     1️⃣ REJECTED — HIGHEST PRIORITY
  ------------------------------ */

        // all rejected (cell + row by both roles)
        if (
          validatorCellRejected &&
          investigatorCellRejected &&
          validatorRowRejected &&
          investigatorRowRejected
        ) {
          backgroundColor = "rgb(235 44 109)";
        }

        // validator cell + validator row + investigator cell
        else if (
          validatorCellRejected &&
          validatorRowRejected &&
          investigatorCellRejected
        ) {
          backgroundColor = "rgb(249 61 61)";
        }

        // validator cell + validator row + investigator row
        else if (
          validatorCellRejected &&
          validatorRowRejected &&
          investigatorRowRejected
        ) {
          backgroundColor = "rgb(253 32 32)";
        }

        // any strong rejection combo (dark red)
        else if (
          (validatorCellRejected && investigatorCellRejected) ||
          (validatorRowRejected && investigatorRowRejected) ||
          (validatorRowRejected && investigatorCellRejected) ||
          (validatorCellRejected && investigatorRowRejected) ||
          (validatorCellRejected && validatorRowRejected)
        ) {
          backgroundColor = "rgb(253 97 71)";
        }

        // any single rejection (light red)
        else if (
          validatorCellRejected ||
          validatorRowRejected ||
          investigatorCellRejected ||
          investigatorRowRejected
        ) {
          backgroundColor = "rgb(255 137 116)";
        } else if (isValidated) {
          /* -----------------------------
     2️⃣ VALIDATED — MEDIUM PRIORITY
  ------------------------------ */
          backgroundColor = "#e5ffdb";
        } else if (validatorCellResolved || validatorRowResolved) {
          /* -----------------------------
     3️⃣ RESOLVED — LOWEST PRIORITY
  ------------------------------ */
          backgroundColor = "#CCE5FF";
        }
      }

      // // Check if one of the inputs has a value while the other doesn't
      // const keyMappingPageNo =
      //   parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData?.pageNo;
      // const valueMappingPageNo =
      //   parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo;

      // const keyMappingCoordinatesLength =
      //   (parametersData[parameterIndex]?.mappings[mappingIndex]
      //     ?.keyCoordinates &&
      //     parametersData[parameterIndex]?.mappings[mappingIndex]?.keyCoordinates
      //       ?.length) ||
      //   0;
      // const valueMappingCoordinatesLength =
      //   (parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates &&
      //     parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates
      //       ?.length) ||
      //   0;

      // if (
      //   (keyMappingPageNo !== "" &&
      //     keyMappingPageNo !== undefined &&
      //     keyMappingPageNo !== null &&
      //     keyMappingPageNo >= 0 &&
      //     (valueMappingPageNo === "" ||
      //       valueMappingPageNo === undefined ||
      //       valueMappingPageNo === null)) ||
      //   (valueMappingPageNo !== "" &&
      //     valueMappingPageNo !== undefined &&
      //     valueMappingPageNo !== null &&
      //     valueMappingPageNo >= 0 &&
      //     (keyMappingPageNo === "" ||
      //       keyMappingPageNo === undefined ||
      //       keyMappingPageNo === null))
      // ) {
      //   backgroundColor = "rgb(241 238 137 / 41%)"; // Red background color
      // } else if (
      //   (keyMappingPageNo !== "" &&
      //     keyMappingPageNo !== undefined &&
      //     keyMappingPageNo !== null &&
      //     keyMappingPageNo >= 0 &&
      //     keyMappingCoordinatesLength <= 0) ||
      //   (valueMappingPageNo !== "" &&
      //     valueMappingPageNo !== undefined &&
      //     valueMappingPageNo !== null &&
      //     valueMappingPageNo >= 0 &&
      //     valueMappingCoordinatesLength <= 0)
      // ) {
      //   backgroundColor = "rgb(241 238 137 / 41%)"; // Red background color
      // }

      return { backgroundColor };
    };

    const disableText = React.useMemo(
      () =>
        Boolean(
          mapping?.isDerivativeField ||
          isDisable(
            mapping,
            mappingIndex,
            parameterIndex,
            role,
            isDataRejectedByProcessor,
            entireBatchRejectedByPro,
            parametersData,
            entireBatchRejectedByVali,
            reProcessEntireBatch,
            reProcess,
            isDataRejectedByValidator,
            reValidate,
            isDataRejectedByInvestigatorMappingValidator,
            entireBatchRejectedByInvestigatorMappingValidator,
            isDataRejectedByInvestigatorValidator,
            entireBatchRejectedByInvestigatorValidator,
          ),
        ),
      [
        mapping,
        mappingIndex,
        parameterIndex,
        role,
        isDataRejectedByProcessor,
        entireBatchRejectedByPro,
        parametersData,
        entireBatchRejectedByVali,
        reProcessEntireBatch,
        reProcess,
        isDataRejectedByValidator,
        reValidate,
        isDataRejectedByInvestigatorMappingValidator,
        entireBatchRejectedByInvestigatorMappingValidator,
        isDataRejectedByInvestigatorValidator,
        entireBatchRejectedByInvestigatorValidator,
      ],
    );

    const tooltipTitle =
      mapping.reInitiateProVlm &&
      mapping.proVlmTagName &&
      mapping.proVlmPageNo >= 0
        ? `${mapping.proVlmTagName} - ${parseInt(mapping.proVlmPageNo) + 1}`
        : "";

    const onCero = (e, type) => {
      if (isDataRejectedByProcessor !== true) {
        if (e.keyCode === 8 || e.keyCode === 46) {
          clearMappings(type);
        }
      }
    };

    const handleCloseMenu = React.useCallback(() => {
      setContextEvent(null);
    }, []);

    const handleClick = React.useCallback((event) => {
      event.preventDefault();

      setContextEvent(event);
    }, []);

    const adjustTextareaHeight = React.useCallback(() => {
      if (resizeFrameRef.current) {
        cancelAnimationFrame(resizeFrameRef.current);
      }
      resizeFrameRef.current = requestAnimationFrame(() => {
        const textarea = textAreaRef.current;
        if (!textarea) {
          return;
        }
        textarea.style.height = "auto"; // Reset the height to auto

        const newHeight = textarea.scrollHeight - 3; // Calculate the new height based on content
        // Set the height to the greater of the scrollHeight or the minHeight
        textarea.style.height = Math.max(newHeight, MIN_TEXTAREA_HEIGHT) + "px";
      });
    }, []);

    React.useEffect(() => {
      return () => {
        if (resizeFrameRef.current) {
          cancelAnimationFrame(resizeFrameRef.current);
        }
      };
    }, []);

    React.useEffect(() => {
      if (document.activeElement === textAreaRef.current) {
        adjustTextareaHeight();
      }
    }, [adjustTextareaHeight, value]);

    // const adjustKeyTextareaHeight = () => {
    //   const textarea = keyTextAreaRef.current;

    //   textarea.style.height = "auto"; // Reset the height to auto
    //   textarea.style.height = textarea.scrollHeight + "px"; // Set the height based on content
    // };

    // React.useEffect(() => {
    //   role === "preProcessor" && adjustKeyTextareaHeight();
    // }, [parameterKey, role]);

    const textareaElement = (
      <textarea
        onKeyDown={
          role === "preProcessor"
            ? (e) => onCero(e, "toResetValueMapping")
            : undefined
        }
        ref={textAreaRef}
        className={` ${"my-textarea"} ${
          disableText
            ? "disableCell"
            : role === "validator"
              ? "disable_opacity"
              : ""
        }`}
        id="outlined-basic"
        style={{
          minHeight: "100%",
          width: "100%",
          resize: "none",
          overflow: "hidden",
          backgroundColor: "transparent",
          // ...(role === "validator" &&
          //   mapping?.is_value_updated === true &&
          //   mappingIndex % 2 === 0 &&
          //   parameterIndex % 2 === 0 && {
          //     WebkitTextFillColor: "#2E7D32",
          //   }),
        }}
        value={value}
        onChange={(e) => {
          if (role === "processor" && !disableText) {
            onChange(e);
          }
        }}
        onBlur={() => {
          if (role === "processor" && !disableText) {
            onBlur();
          }
        }}
        onClick={(e) => {
          if (role === "preProcessor") {
            if (!disableText) {
              onClickMapping(e, parameterIndex, mappingIndex);
            }
          } else {
            onClickCellToRedirect(
              e,
              mapping?.tagName,
              mapping?.pageNo,
              mapping?.fileNo,
              parameterIndex,
              mappingIndex,
              mapping?.coordinates,
              disableText,
              mapping?.actual_page_number,
            );
          }
        }}
        onFocus={adjustTextareaHeight}
        onInput={adjustTextareaHeight}
        disabled={role !== "processor" && disableText}
        rows={1}
      />
    );

    return (
      <div className="cell-main">
        <div
          className="cell-outer"
          onContextMenu={(e) => {
            if (showContextMenu) {
              handleClick(e);
            }
          }}
          style={{
            ...styleRejectedCell(
              mapping,
              mappingIndex,
              rowRejectionData,
              parameterIndex,
            ),
            ...{
              padding: "0px 15px 0px 5px",
            },
            // to heighlight selected  cell for re initiate vlm

            ...(mapping?.reInitiateProVlm && {
              border: "2px solid #2776d2", // Example for "selected for reprocess"
            }),
            ...(role === "validator" &&
              mapping?.is_value_updated === true && {
                borderLeft: "2px solid #2E7D32",
              }),
          }}
        >
          {/* {role === "preProcessor" && (
            <>
               // key mapping, only used to send key mappings to improve ai but all remeanig functionality like disable color and all based on cell level data/mapping/variables 
              <div style={{ flex: 1, height: "50%" }}>
                <textarea
                  onKeyDown={(e) =>
                    role === "preProcessor" && onCero(e, "toResetKeyMapping")
                  }
                  ref={keyTextAreaRef}
                  className={`${
                    role === "preProcessor"
                      ? "my-textarea-min-height"
                      : "my-textarea"
                  } ${
                    disableText
                      ? "disableCell"
                      : role === "validator"
                      ? "disable_opacity"
                      : ""
                  }`}
                  id="outlined-basic"
                  style={{
                    ...(role !== "preProcessor" && { minHeight: "100%" }),
                    width: "100%",
                    resize: "none",
                    overflow: "hidden",
                    backgroundColor: "transparent",
                    // },
                  }}
                  value={parameterKey}
                  onBlur={() =>
                    // in pre on blur only storing logs
                    !isDisableWrapper(mapping, mappingIndex, parameterIndex) &&
                    onBlur("parameterKeyMapping")
                  }
                  onClick={(e) =>
                    !isDisableWrapper(mapping, mappingIndex, parameterIndex) &&
                    onClickParameterKeyMapping(e, parameterIndex, mappingIndex)
                  }
                  onInput={(e) => {
                    // Calculate and set the textarea's height based on content
                    e.target.style.height = "auto";
                    e.target.style.height = e.target.scrollHeight + "px";
                  }}
                  disabled={isDisableWrapper(
                    mapping,
                    mappingIndex,
                    parameterIndex
                  )}
                  placeholder={role === "preProcessor" ? "Parameter" : ""}
                  rows={1}
                />
              </div>
              <Divider variant="fullWidth" className="divider-editable" />
            </>
          )} */}
          {/* <div className={role === "preProcessor" ? "h-48" : "h-100"}> */}

          {tooltipTitle ? (
            <Tooltip placement="top" title={tooltipTitle} arrow>
              {textareaElement}
            </Tooltip>
          ) : (
            textareaElement
          )}
          {/* </div> */}
          {showContextMenu && contextEvent && (
            <ContextMenu
              showContextMenu={showContextMenu}
              isOpemContextMenu={Boolean(contextEvent)}
              handleCloseMenu={handleCloseMenu}
              updateDataUsingManuallyContextMenu={
                updateDataUsingManuallyContextMenu
              }
              parameterIndex={parameterIndex}
              mappingIndex={mappingIndex}
              contextEvent={contextEvent}
            />
          )}
        </div>
      </div>
    );
  },
);

const EditableCell = ({
  mapping,
  mappingIndex,
  parameterIndex,
  parametersData,
  setParametersData,
  rowRejectionData,
  role,
  onClickMapping,
  onClickCellToRedirect,
  anyOperationPerformedOnEntirePage,
  reProcess,
  isDataRejectedByProcessor,
  isDataRejectedByValidator,
  reValidate,
  clearMappings,
  entireBatchRejectedByPro,
  entireBatchRejectedByVali,
  reProcessEntireBatch,
  showContextMenu,
  updateDataUsingManuallyContextMenu,
  selectedFilesDataForProUpdate,
  setLogs,
  selectedFile,
  coordinatesData,
  updateLastSelectedPageForProUpdateMapping,
  isDataRejectedByInvestigatorMappingValidator,
  entireBatchRejectedByInvestigatorMappingValidator,
  isDataRejectedByInvestigatorValidator,
  entireBatchRejectedByInvestigatorValidator,
  // onClickParameterKeyMapping,
}) => {
  const textValue = (mapping) => {
    let value = "";

    if (role === "preProcessor") {
      value =
        mapping?.lockedPreTagName && mapping.lockedPrePageNo >= 0
          ? `${mapping?.lockedPreTagName} - ${
              parseInt(mapping.lockedPrePageNo) + 1
            }`
          : // :
            // mapping?.tagName && mapping.pageNo >= 0
            // ? `${mapping?.tagName} - ${parseInt(mapping.pageNo) + 1}`
            "";
    } else {
      value = mapping?.value;
    }
    return value;
  };

  // const keyTextValue = (keyMapping) => {
  //   let value = "";

  //   if (role === "preProcessor") {
  //     value =
  //       keyMapping?.tagName && keyMapping.pageNo >= 0
  //         ? `${keyMapping?.tagName} - ${parseInt(keyMapping.pageNo) + 1}`
  //         : "";
  //   }
  //   return value;
  // };

  const initialValue = textValue(mapping);
  // const initialKeyValue = keyTextValue(mapping?.keyData);

  const [value, setValue] = React.useState(initialValue);
  // const [parameterKey, setParameterKey] = React.useState(initialKeyValue);
  // If the initialValue is changed external, sync it up with our state
  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  // React.useEffect(() => {
  //   setParameterKey(initialKeyValue);
  // }, [initialKeyValue]);

  const onChange = (e) => {
    let value = e.target.value;
    const regex = /\n/g;
    value = value.replace(regex, "");
    setValue(value);
  };

  // We'll only update the external data when the input is blurred
  const onBlur = (string) => {
    // called only in pro role in vali cell is disabled so its not calling
    if (role === "processor") {
      let valueBeforeChange = "";

      if (parametersData[parameterIndex].mappings[mappingIndex]) {
        valueBeforeChange =
          parametersData[parameterIndex]?.mappings[mappingIndex]?.value;

        parametersData[parameterIndex].mappings[mappingIndex] = {
          ...parametersData[parameterIndex].mappings[mappingIndex],
          value: value,
          processor: localStorage?.userName,
          processedDate: moment(new Date()).format("DD-MMM-YYYY"),
          // is_value_updated: true, commenting because storing accurate key from backend by value comparision
          previousValue: valueBeforeChange,
        };

        if (
          parametersData[parameterIndex].mappings[mappingIndex]?.tagName &&
          parametersData[parameterIndex].mappings[mappingIndex]?.fileNo &&
          parametersData[parameterIndex].mappings[mappingIndex]?.pageNo
        ) {
          updateLastSelectedPageForProUpdateMapping({
            tagName:
              parametersData[parameterIndex].mappings[mappingIndex]?.tagName,
            fileNo:
              parametersData[parameterIndex].mappings[mappingIndex]?.fileNo,
            pageNo:
              parametersData[parameterIndex].mappings[mappingIndex]?.pageNo,
          });
        }
      }

      if (
        parametersData[parameterIndex].mappings[mappingIndex]?.pageNo === "" &&
        parametersData[parameterIndex].mappings[mappingIndex]?.tagName === "" &&
        parametersData[parameterIndex].mappings[mappingIndex]?.value !== ""
      ) {
        parametersData[parameterIndex].mappings[mappingIndex] = {
          ...parametersData[parameterIndex].mappings[mappingIndex],
          fileNo: selectedFilesDataForProUpdate?.fileNo,
          pageNo: selectedFilesDataForProUpdate?.pageNo,
          tagName: selectedFilesDataForProUpdate?.tagName,
          lockedPreTagName: selectedFilesDataForProUpdate?.tagName,
          lockedPrePageNo: selectedFilesDataForProUpdate?.pageNo,
          lockedPreFileNo: selectedFilesDataForProUpdate?.fileNo,
          forNoPreProMappingDataEntryByPro: true,
          actual_page_number: selectedFilesDataForProUpdate?.pageNo,
          // is_value_updated: true, commenting because storing accurate key from backend by value comparision
          previousValue: valueBeforeChange,
        };

        // for insertion of logs
        setLogs((prevLogs) => [
          ...prevLogs,
          logObject({
            extractionType: "template",
            category: "dataEntry",
            action:
              // string === "valueMapping"
              //   ?
              "Mapping added by Processor for unmapped data",
            // : "Add Parameter Key Mapping",
            parameter: parametersData[parameterIndex]?.parameter,
            dataType: parametersData[parameterIndex]?.dataType,
            rangeMin: parametersData[parameterIndex]?.range?.["min"],
            rangeMax: parametersData[parameterIndex]?.range?.["max"],
            coordinates:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[mappingIndex]
                ?.coordinates,
            // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
            //     ?.coordinates,
            coordinatesValues:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[mappingIndex]
                ?.coordinatesValues,
            // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
            //     ?.coordinatesValues,

            tagName:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[mappingIndex]?.tagName,
            // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
            //     ?.tagName,

            pageNo:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo,
            // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
            //     ?.pageNo,

            fileNo:
              // string === "valueMapping"
              //   ?
              parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo,
            // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
            //     ?.fileNo,

            rowColIndex: [
              parseInt(parameterIndex) + 1,
              parseInt(mappingIndex) + 1,
            ],
            mbrName: selectedFile?.originalFileName || "",
            document:
              coordinatesData[selectedFile?.fileNo]?.pages[selectedFile?.pageNo]
                ?.imageUrl,
          }),
        ]);
      }

      setParametersData([...parametersData]);
      if (!anyOperationPerformedOnEntirePage.current) {
        anyOperationPerformedOnEntirePage.current = true;
      }
      if (valueBeforeChange !== value) {
        setLogs((prevLogs) => [
          ...prevLogs,
          logObject({
            extractionType: "template",
            category: "dataEntry",
            action: "Data Entered",
            parameter: parametersData[parameterIndex]?.parameter,
            value: value,
            dataType: parametersData[parameterIndex]?.dataType,
            rangeMin: parametersData[parameterIndex]?.range?.["min"],
            rangeMax: parametersData[parameterIndex]?.range?.["max"],
            coordinates:
              parametersData[parameterIndex]?.mappings[mappingIndex]
                ?.coordinates,
            coordinatesValues:
              parametersData[parameterIndex]?.mappings[mappingIndex]
                ?.coordinatesValues,
            tagName:
              parametersData[parameterIndex].mappings[mappingIndex]?.tagName,
            pageNo:
              parametersData[parameterIndex].mappings[mappingIndex]?.pageNo,
            fileNo:
              parametersData[parameterIndex].mappings[mappingIndex]?.fileNo,
            rowColIndex: [
              parseInt(parameterIndex) + 1,
              parseInt(mappingIndex) + 1,
            ],
            mbrName: selectedFile?.originalFileName,
            document:
              coordinatesData[
                parseInt(
                  parametersData[parameterIndex]?.mappings[mappingIndex]
                    ?.fileNo,
                )
              ]?.pages[
                parseInt(
                  parametersData[parameterIndex]?.mappings[mappingIndex]
                    ?.pageNo,
                )
              ]?.imageUrl,
          }),
        ]);
      }
    }

    // if (role === "preProcessor") {
    //   if (
    //     selectedFile?.tagName !==
    //       parametersData[parameterIndex]?.mappings[mappingIndex]?.tagName ||
    //     selectedFile?.fileNo !==
    //       parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo ||
    //     selectedFile?.pageNo !==
    //       parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo
    //   ) {
    //     // for insertion of logs
    //     setLogs((prevLogs) => [
    //       ...prevLogs,
    //       logObject({
    //         extractionType: "template",
    //         category: "mapping",
    //         action:
    //           // string === "valueMapping"
    //           //   ?
    //           "Value Mapping Added",
    //         // : "Key Mapping Added",
    //         parameter: parametersData[parameterIndex]?.parameter,
    //         dataType: parametersData[parameterIndex]?.dataType,
    //         rangeMin: parametersData[parameterIndex]?.range?.["min"],
    //         rangeMax: parametersData[parameterIndex]?.range?.["max"],
    //         coordinates:
    //           // string === "valueMapping"
    //           //   ?
    //           parametersData[parameterIndex]?.mappings[mappingIndex]
    //             ?.coordinates,
    //         // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
    //         //     ?.coordinates,
    //         coordinatesValues:
    //           // string === "valueMapping"
    //           //   ?
    //           parametersData[parameterIndex]?.mappings[mappingIndex]
    //             ?.coordinatesValues,
    //         // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
    //         //     ?.coordinatesValues,

    //         tagName:
    //           // string === "valueMapping"
    //           //   ?
    //           parametersData[parameterIndex]?.mappings[mappingIndex]?.tagName,
    //         // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
    //         //     ?.tagName,

    //         pageNo:
    //           // string === "valueMapping"
    //           //   ?
    //           parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo,
    //         // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
    //         //     ?.pageNo,

    //         fileNo:
    //           // string === "valueMapping"
    //           //   ?
    //           parametersData[parameterIndex]?.mappings[mappingIndex]?.fileNo,
    //         // : parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
    //         //     ?.fileNo,

    //         rowColIndex: [
    //           parseInt(parameterIndex) + 1,
    //           parseInt(mappingIndex) + 1,
    //         ],
    //         mbrName: selectedFile?.originalFileName || "",
    //         document:
    //           coordinatesData[selectedFile?.fileNo]?.pages[selectedFile?.pageNo]
    //             ?.imageUrl,
    //       }),
    //     ]);
    //   }
    // }
  };

  return (
    <MemoisedTextArea
      role={role}
      parametersData={parametersData}
      mapping={mapping}
      mappingIndex={mappingIndex}
      rowRejectionData={rowRejectionData}
      parameterIndex={parameterIndex}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      isDataRejectedByProcessor={isDataRejectedByProcessor}
      reProcess={reProcess}
      isDataRejectedByValidator={isDataRejectedByValidator}
      reValidate={reValidate}
      onClickMapping={onClickMapping}
      onClickCellToRedirect={onClickCellToRedirect}
      clearMappings={clearMappings}
      entireBatchRejectedByPro={entireBatchRejectedByPro}
      entireBatchRejectedByVali={entireBatchRejectedByVali}
      reProcessEntireBatch={reProcessEntireBatch}
      showContextMenu={showContextMenu}
      updateDataUsingManuallyContextMenu={updateDataUsingManuallyContextMenu}
      isDataRejectedByInvestigatorMappingValidator={
        isDataRejectedByInvestigatorMappingValidator
      }
      entireBatchRejectedByInvestigatorMappingValidator={
        entireBatchRejectedByInvestigatorMappingValidator
      }
      isDataRejectedByInvestigatorValidator={
        isDataRejectedByInvestigatorValidator
      }
      entireBatchRejectedByInvestigatorValidator={
        entireBatchRejectedByInvestigatorValidator
      }
      // parameterKey={parameterKey}
      // onClickParameterKeyMapping={onClickParameterKeyMapping}
    />
  );
};

export default React.memo(EditableCell);
